import styled from "styled-components";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";

export const StyledFixaModalBody = styled(FixaModalBody)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledFixaModalFooter = styled(FixaModalFooter)`
  display: grid;
  gap: 8px;
`;
